import defenceSymbol from "../assets/battles/defence.png";

const defenceBuilder = (defence, font) => {
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d");
	canvas.width = 95;
	canvas.height = 85;
	ctx.clearRect(0, 0, canvas.width, canvas.height);
	ctx.font = font;
	return new Promise((resovle, reject) => {
		const img = document.createElement("img");
		img.src = defenceSymbol;
		img.onload = () => resovle(img);
	}).then((img) => {
		ctx.drawImage(img, 0, 0, 95, 85);
		const defenceString = `${defence}`;
		const halfTextLength = Math.round(ctx.measureText(defenceString).width / 2);
		const halfCanvas = Math.round(canvas.width / 2);
		const x = halfCanvas - halfTextLength;
		ctx.fillStyle = "#FFF";
		ctx.fillText(defenceString, x, 57);
		return canvas.toDataURL("image/png");
	});
};

export default defenceBuilder;
